import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getIconClassName from '../../helpers/getIconClassName';
import s from '../../IconV2.scss';

const DisabledRadioIcon32: FC<IconV2Props> = ({
  icon,
  chroma,
  className,
  size,
}) => {
  return (
    <svg
      className={cn(
        getIconClassName(chroma as string, size as string, s),
        `svg-icon--${icon}`,
        className
      )}
      width="32"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      data-icon={`${icon}-32`}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16Z"
          fill="#ECEDED"
          fillRule="nonzero"
        />
        <path
          d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm0-1.455C7.967 30.545 1.455 24.033 1.455 16 1.455 7.967 7.967 1.455 16 1.455c8.033 0 14.545 6.512 14.545 14.545 0 8.033-6.512 14.545-14.545 14.545Z"
          fill="#D5D6D6"
        />
        <path
          stroke="#D5D6D6"
          strokeWidth="2"
          strokeLinecap="square"
          d="M8.667 16h14.666"
        />
      </g>
    </svg>
  );
};

export default DisabledRadioIcon32;
